﻿import { apiUsers } from "../api/axiosClient";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { modal } from "../utils/antdStatic";
import { logoutThunk } from "../redux/state/loginstate/user";
import { persistor } from "../redux/store";
import { STORAGE_SESSION_ACTIVE } from "../utils/storageKeys";
import { toast } from "../utils/toast";
import { getApiError } from "../utils/getApiError";

const ConfirmLogout = () => {
  /* --------------------------  --------------------------  */

  const [error, setError] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [status, setStatus] = useState("");
  const [mensaje, setMensaje] = useState("");

  /* --------------------------  --------------------------  */

  const navigate = useNavigate();

  /* --------------------------  --------------------------  */

  const dispatch = useDispatch();

  /* --------------------------  --------------------------  */

  const userdata = useSelector((state) => state.user);
  const { codigoAfiliado } = userdata;

  /* --------------------------  --------------------------  */
  const HandleConfirmLogout = () => {
    modal.confirm({
      title: "¿Estás seguro de que quieres cerrar la sesión?",
      okText: "Aceptar",
      cancelText: "Cancelar",
      okButtonProps: { danger: true },
      onOk: async () => {
        setIsFetching(true);

        try {
          // 1. Cierra sesión en Redux y limpia el storage persistente
          await dispatch(logoutThunk());
          await persistor.purge();

          // 2. Llama al backend para cerrar sesión
          const response = await apiUsers.delete("/eliminarLogin", {
            params: { codigoAfiliado },
          });

          if (response.status === 200) {
            const { mensaje } = response.data;
            setStatus(response.status);
            setMensaje(mensaje);
            localStorage.setItem(STORAGE_SESSION_ACTIVE, "false");
            toast.success("Sesión cerrada.");
            navigate("/", { replace: true });
          }
        } catch (error) {
          const msg = getApiError(error, "Ocurrió algo inesperado.");
          setError(msg);
          setMensaje(msg);
          toast.warning(msg);
        } finally {
          setIsFetching(false);
        }
      },
    });
  };

  /* --------------------------  --------------------------  */

  return { error, status, mensaje, isFetching, HandleConfirmLogout };
};

export default ConfirmLogout;
